import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/specification_subgroups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listSpecificationSubgroups, updateSpecificationSubgroup } from "../../../redux/actions/table/superadmin/specification_subgroups";
import EditSpecificationSubgroupForm from "../../../forms/superadmin/specification_subgroups/EditSpecificationSubgroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateSpecificationSubgroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listSpecificationSubgroups();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditSpecificationSubgroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'code', 'product_subgroups', 'specification_group_id', 'boq_template_subgroup_id']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
